
import { appConfig } from "@env/app-config";
PrivacyPolicyDirective.$inject = ["$uibModal"];
export function PrivacyPolicyDirective($uibModal: angular.ui.bootstrap.IModalService): angular.IDirective {
    return {
        restrict: 'EA',
        scope: {
            // 根地址路径
            rootPath: "<",
            // 用户隐私权限确认状态
            confirmPrivacyPolicy: "=",
            // 本地缓存-用户隐私权限确认状态
            cachePrivacyPolicy:'='
        },
        // transclude: true,
        controllerAs: "$ctrl",
        controller: ["$scope", "$templateCache", function ($scope, $templateCache: angular.ITemplateCacheService) {
            let ctrl = this;
            ctrl.$onInit = () => {
                ctrl.rootPath = $scope.rootPath;
                ctrl.confirmPrivacyPolicy = $scope.confirmPrivacyPolicy;
                // 网站平台类型
                ctrl.websiteCode = appConfig.websiteCode.toUpperCase();

            }

            ctrl.openPrivacyPolicy = () => {
                let modalInstance = $uibModal.open({
                    size: "lg",
                    windowClass: "regist-privacy-modal",
                    backdrop: "static", // 能否通过点击背景关闭
                    keyboard: true,  // 模态框能否通过Esc关闭
                    controller: "privacyPolicyModalCtrl",
                    controllerAs: "privacyCtrl",
                    templateUrl: "privacy-policy-modal.html",
                    resolve: {
                        items: () => {
                            return {
                                rootPath: $scope.rootPath,
                                confirmPrivacyPolicy: $scope.confirmPrivacyPolicy?$scope.confirmPrivacyPolicy:false,
                                cachePrivacyPolicy:$scope.cachePrivacyPolicy?$scope.cachePrivacyPolicy:false
                            }
                        }
                    }
                });
                // 接收模态框参数
                modalInstance.result.then((res) => {
                    if (res) {
                        $scope.confirmPrivacyPolicy = res.confirmPrivacyPolicy;
                        $scope.cachePrivacyPolicy = res.cachePrivacyPolicy;
                    }
                }, reason => {
                    console.log(reason);
                });
            }
        }],
        templateUrl: "privacy-policy.html",
        link: (scope: angular.IScope, elements: any, attributes: angular.IAttributes, ctrls: angular.IController): void => {

        }
    };
}

